import { initialMapTypesState } from 'constants/map';
import { CoordinateSystems } from 'types';

import { SettingsState } from './types';

export const initialState: SettingsState = {
  types: initialMapTypesState,
  centerCoords: '',
  coordsMode: CoordinateSystems.SK42,
  showAim: false,
  showCustomCursors: true,
  showLabels: true,
  showObjects: true,
  clusterObjects: true,
  showObjectIDs: false,
};
